import { useCallback } from 'react';
import { NavigateOptions, useNavigate } from 'react-router-dom';

import { useAppContext } from '../context/app-context';

type NavigationOptionsExtended = NavigateOptions & {
  withoutHealthProviderId?: boolean;
};

export const useNavigateWithHealthProvider = () => {
  const navigate = useNavigate();

  const { healthProviderId } = useAppContext();

  const onHandleNavigate = useCallback(
    (to: string, options?: NavigationOptionsExtended) => {
      if (options?.withoutHealthProviderId) {
        navigate(to, options);
      } else {
        navigate(
          `/${[healthProviderId, to.replace(/^\/|\/$/g, '')]
            .filter(option => option)
            .join('/')}`,
          options
        );
      }
    },
    [healthProviderId, navigate]
  );

  return onHandleNavigate;
};
